module.exports = __webpack_public_path__ + "static/img/TG.7ba94a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/funImg/TG.png
// module id = 0BOG
// module chunks = 1